import React from 'react';
import { Button } from 'rsuite';
import { FormModal } from '../../common/FormModal';
import BlogCategoryModalContent from './BlogCategoryModalContent';

type Props = {
  open: boolean;
  onClose: () => void;
  slug: string;
  title: string;
  titleEn: string;
  titleDe: string;
  setSlug: (value: string) => void;
  setTitle: (value: string) => void;
  setTitleEn: (value: string) => void;
  setTitleDe: (value: string) => void;
  onSave: () => void;
  errorSummary?: string[];
};

export default function EditBlogCategoryModal({
  open,
  onClose,
  slug,
  title,
  titleEn,
  titleDe,
  setSlug,
  setTitle,
  setTitleEn,
  setTitleDe,
  onSave,
  errorSummary = [],
}: Props) {
  return (
    <FormModal
      open={open}
      onClose={onClose}
      title="Редагувати категорію"
      errorSummary={errorSummary}
      footer={
        <>
          <Button onClick={onSave} appearance="primary">
            Зберегти
          </Button>
          <Button onClick={onClose} appearance="subtle">
            Скасувати
          </Button>
        </>
      }
    >
      <BlogCategoryModalContent
        slug={slug}
        title={title}
        titleEn={titleEn}
        titleDe={titleDe}
        setSlug={setSlug}
        setTitle={setTitle}
        setTitleEn={setTitleEn}
        setTitleDe={setTitleDe}
      />
    </FormModal>
  );
}
